
export default {
  computed: {
    items() {
      return [
        {
          icon: 'bell',
          name: this.$t('Layout.greeting'),
          url: {
            name: 'home',
          },
        },
        {
          icon: 'flag',
          name: `${this.$t('Layout.greeting')} 2`,
          url: {
            name: 'home',
          },
          children: [
            {
              icon: 'hexagon-multiple',
              name: `${this.$t('Layout.greeting')} 2.1`,
              url: {
                name: 'home',
              },
            },
            {
              icon: 'account-multiple',
              name: `${this.$t('Layout.greeting')} 2.2`,
              url: {
                name: 'home',
              },
            },
          ],
        },
      ];
    },
  },
};
